<template>
 <basiCcontainer class="backStage-index">
    <template #head>
      <div class="left">
        <i class="icon iconfont iconicon_arrow_task_2 taskHoverIcon" @click="goBack"></i>
      </div>
      <div class="right">
        <span style="margin-right: 119px;" :class="{'active': active === 'editHelpPage'}" @click="linkTo('editHelpPage')">帮助中心</span>
        <span :class="{'active': active === 'notice'}" @click="linkTo('notice')">通知</span>
      </div>
    </template>
    <router-view></router-view>
 </basiCcontainer>
</template>
<script>
export default {
  computed: {
    active() {
      return this.$route.name
    }
  },
  created() {
  },
  methods: {
    linkTo(name) {
      this.$router.push({
        name
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss">
.backStage-index {
  .search-box {
    display: flex;
    align-items: center;
    padding: 0 24px;
    position: relative;
    .right {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      height: 100%;
      display: flex;
      align-items: center;
      color: rgba(32, 32, 32, 0.6);
      span {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
        &:hover {
          color: initial;
        }
      }
      .active {
        color: initial;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: #2682FF;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
